import { createEmptyHandlingUnitRow } from "@RequestFormV2/defaults/packingListDefaults";
import { DEFAULT_SERVICE_TYPE } from "@RequestFormV2/utils/serviceTypeOptions";
import { getUnitSystemPreferences } from "@RequestFormV2/utils/getUnitSystemPreferences";
import { normalizeDraftSchedule } from "@RequestFormV2/utils/normalizeDraftSchedule";

export function getRequestFormV2DefaultValues() {
  const { weightUnit, dimensionUnit } = getUnitSystemPreferences(
    typeof localStorage !== "undefined" ? localStorage.getItem("cargobase_userpermissions") : null,
  );

  return {
    draftSaved: false,
    organizational: {
      location: "",
      invoice_location: "",
      goods_confirmation_type: "Estimated",
    },
    shipment: {
      title: "",
      quoting_deadline_date: "",
      quoting_deadline_time: "",
      confirmation_date: "",
      confirmation_time: "",
      comments: "",
    },
    invited_modes: {},
    service: {
      service_type: DEFAULT_SERVICE_TYPE,
      incoterms: "none",
      incoterm_instructions: "",
      insurance_instructions: "",
      special_requirements: {},
    },
    schedule: normalizeDraftSchedule(undefined),
    packing_list: [createEmptyHandlingUnitRow({ m_unit: dimensionUnit, w_unit: weightUnit })],
    invited_providers: {
      providers: [],
      parcel_accounts: [],
    },
    bucket_attachments: [],
    other_attachments: [],
  };
}
